import React from 'react';
import PropTypes from 'prop-types';
import {
  FDAlert,
  FDDialog,
  FDDialogContent,
  FDDialogTitle,
} from '@facet-wealth/design';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import Layout from './Layout';
import SubmitNextUpReviewPageConfirmationModalWithActionItemsOverride from './metaOverride';

export default function SubmitNextUpReviewPageWithActionItemsConfirmationDialog({
  resource,
  open,
  onConfirm,
  onClose,
  loading,
}) {
  return (
    <FDDialog
      open={open}
      onClose={onClose}
    >
      <FDDialogTitle value={'Confirm Next Up Review'} />
      <FDDialogContent>
        <FDAlert title="When the member selects this roadmap, all existing outstanding Actions created via Next Up will be automatically deleted and replaced with new ones from this scenario." />
        <br />
        <MetaFormInline
          resource={resource}
          noIndividualSubmitButtons
          metaOverrideSet={SubmitNextUpReviewPageConfirmationModalWithActionItemsOverride}
          layout={Layout}
          padding="none"
          LayoutProps={{
            onConfirm,
            loading,
          }}
        />
      </FDDialogContent>
    </FDDialog>
  );
}

SubmitNextUpReviewPageWithActionItemsConfirmationDialog.propTypes = {
  resource: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};
